module.exports = __webpack_public_path__ + "static/media/3.78962450.jpg";